/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathAvg = createReactComponent("math-avg", "IconMathAvg", [
  ["path", { d: "M3 21l18 -18", key: "svg-0" }],
  ["path", { d: "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0", key: "svg-1" }]
]);

export { IconMathAvg as default };
//# sourceMappingURL=IconMathAvg.js.map
